










































































import { Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import Loader from "@/resources/mixins/loader/loader";
@Component({
  name: "pin-modal-component",
})
export default class PinModalComponent extends mixins(Loader) {
  loading = true;
  count = 3;
  timerCountdown;

  mounted(): void {
    this.$store.dispatch("SuperSpaceStore/setSuperSpaceAction", null);
    this.$store.dispatch("SuperSpaceStore/getSuperSpaceByIdAction", {
      superSpaceId: this.superSpaceId,
      callback: () => {
        this.loading = false;
        //do nothing
      },
    });
  }
  get superSpaceId(): number {
    return this.$store.getters["SystemStore/getSelectedPinSuperSpaceId"];
  }
  get superSpace(): any {
    return this.$store.getters["SuperSpaceStore/getSuperSpace"];
  }
  get activeCountDown(): boolean {
    const activate = this.$store.getters["SystemStore/getPinCountDown"];
    if (activate) this.countdown();
    else {
      clearTimeout(this.timerCountdown);
      this.count = 3;
    }
    return activate;
  }
  countdown(): void {
    this.timerCountdown = setTimeout(() => {
      this.count--;
      if (this.count >= 0) this.countdown();
      else {
        this.$store.dispatch("SystemStore/setPinCountDownModalAction", false);
      }
    }, 1000);
  }
  async goToSpace(): Promise<void> {
    this.startLoader(this.$store);
    await this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    await this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);

    await this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: this.superSpaceId,
      callback: (response) => {
        if (response.length == 1) {
          localStorage.setItem("space_default", response[0].id.toString());
          localStorage.setItem("city", "OFF");
          window.location.reload();
        } else {
          this.$store.dispatch(
            "SystemStore/setSelecSuperSpaceIdAction",
            this.superSpaceId
          );
          this.$store.dispatch(
            "SystemStore/setOpenChangeSpaceModalAction",
            true
          );
        }
      },
    });
  }
}
